import { useSelector } from "react-redux";
import {
  IonCard,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonList,
  IonText,
  isPlatform,
} from "@ionic/react";
// Selectors
import { selectListGroupedByDate } from "../../../store/paymentNoticesList/selectors/selectListGroupedByDate";
import { selectFindStatus } from "../../../store/paymentNoticesList/selectors/selectFindStatus";
// Components
import { PaymentNoticeListSkeletonLoading } from "./PaymentNoticeListSkeletonLoading";
import { PaymentNoticeListItem } from "./PaymentNoticeListItem";

export const PaymentNoticeListByDate: React.FC = () => {
  const paymentNoticesGroupedByDate = useSelector(selectListGroupedByDate);
  const findStatus = useSelector(selectFindStatus);
  return (
    <IonCard
      class={
        isPlatform("desktop")
          ? "ion-margin"
          : "ion-no-margin ion-margin-vertical"
      }
    >
      {findStatus === "pending" && <PaymentNoticeListSkeletonLoading />}
      {findStatus !== "pending" && paymentNoticesGroupedByDate.length === 0 && (
        <p className="ion-text-center" style={{ fontWeight: 300 }}>
          No se han encontrado resultados
        </p>
      )}
      {findStatus !== "pending" && paymentNoticesGroupedByDate.length > 0 && (
        <IonList class="ion-no-padding">
          {paymentNoticesGroupedByDate.map((dateItem) => {
            return (
              <IonItemGroup key={dateItem.dateLabel}>
                <IonItemDivider sticky={true}>
                  <IonLabel>
                    <IonText color="tertiary">
                      <strong>{dateItem.dateLabel}</strong>
                    </IonText>
                  </IonLabel>
                </IonItemDivider>
                {dateItem.items.map((paymentNotice) => (
                  <PaymentNoticeListItem
                    paymentNotice={paymentNotice}
                    key={paymentNotice.id}
                  />
                ))}
              </IonItemGroup>
            );
          })}
        </IonList>
      )}
    </IonCard>
  );
};
